import request from '../untils/request';

export const secKillApi = params => {
  return request({
    url: '/activity/sec-kill/index',
    params,
    authCode: 'SEC-KILL_INDEX',
  });
};

export const secKillSearchGoodsApi = params => {
  return request({
    url: '/activity/sec-kill/search-goods',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const secKillSearchGoodsSkuApi = params => {
  return request({
    url: '/activity/sec-kill/goods-sku',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillCreate = params => {
  return request({
    url: '/activity/sec-kill/create',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillUpdate = params => {
  return request({
    url: '/activity/sec-kill/update',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillDetail = params => {
  return request({
    url: '/activity/sec-kill/detail',
    params,
    authCode: 'SEC-KILL_DETAIL',
  });
};

export const activitySeclillDel = params => {
  return request({
    url: '/activity/sec-kill/delete',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillStop = params => {
  return request({
    url: '/activity/sec-kill/stop',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillRelease = params => {
  return request({
    url: '/activity/sec-kill/release',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillPullMsg = params => {
  return request({
    url: '/activity/sec-kill/pull-msg',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillSendMsg = params => {
  return request({
    url: '/activity/sec-kill/send-sms',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const activitySeclillDeleteGoods = params => {
  return request({
    url: '/activity/sec-kill/delete-goods',
    params,
    authCode: 'SECKILL_EDIT',
  });
};

export const relayGoodsListApi = params => {
  return request({
    url: '/activity/relay/index',
    params,
  });
};

export const relayRemoveApi = params => {
  return request({
    url: '/activity/relay/remove',
    params,
  });
};

export const relayBindGoodsApi = params => {
  return request({
    url: '/activity/relay/bind',
    params,
  });
};
